<template>
<div class="nodataTemplate">

 <div class="accordian-table" v-if="cloading && checkLocading">
    <table  class="vs-table vs-table--tbody-table">
   <tr  v-for="item in  numberOfItems" class="tr-values vs-table--tr tr-table-state-null selected">
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
   </tr>
   <!--
   <tr class="tr-values vs-table--tr tr-table-state-null selected">
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
   </tr>
   <tr class="tr-values vs-table--tr tr-table-state-null selected">
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
   </tr>
   <tr class="tr-values vs-table--tr tr-table-state-null selected">
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
   </tr>
   <tr class="tr-values vs-table--tr tr-table-state-null selected">
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
   </tr>
   <tr class="tr-values vs-table--tr tr-table-state-null selected">
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
    <td class="td vs-table--td"><div class="skline"></div></td>
   </tr>
    -->
   </table>
 </div>
  <div class="wrapTpl d-flex flex-col items-center" v-else >
      <!-- <img v-if="type=='workflow'" src="@/assets/images/emptystates/workflow.svg"   />
      <img v-else-if="type=='petitions'" src="@/assets/images/emptystates/petitions.svg"   />
       <img v-else-if="type=='branches'" src="@/assets/images/emptystates/branch.svg"   />
      <img v-else-if="type=='petitioner'" src="@/assets/images/emptystates/petitioner.svg"   />
      <img v-else-if="type=='documents'|| type=='Documents'" src="@/assets/images/emptystates/petitions.svg"   />
      <img v-else src="@/assets/images/emptystates/support.svg"   /> -->
      <img v-if="type=='empNotSignedI9'" src="@/assets/images/emptystates/petitions.svg"   />
      <img v-else-if="type == 'error'" src="@/assets/images/main/no-data-img.png"   />
      <img v-else src="@/assets/images/main/nodata_global.svg"   />

   <h3 v-if="heading" v-html="heading">{{heading}}</h3>
   <p v-if="content" v-html="content">{{content}}</p>

   <!-- Button Retry for the list pages when error occured -->
   <a v-if="isError" class="btn theme_btn nowrap self-center mt-2" @click="retry">Retry</a>

   <!-- Button to clear all Filters -->
   <a v-if="isNoFilters" class="btn theme_btn nowrap self-center mt-2" @click="clearFilters">Clear filters</a>
  

         



</div>

</div>
</template>

<script>
export default {
    props: {
      isError: false,
      isNoFilters: false,
      numberOfItems:{
        type:Number,
        default:6
      },
     loading:true,
     type:null,
     heading:null,
     content:null,
     checkLocading:{
      type:Boolean,
      default:true
     },  
    },
     watch: { 
      	loading: function(newVal, oldVal) { // watch it
        }
      },
      data() {
        return {
         cloading:true
        };
    },
    mounted(){
        var _s = this;
       setTimeout(function(){

           // _s.cloading =_s.loading;
           
       },500)
      
    },
    methods: {
      updateLoading(value){
        this.cloading = value;
      
      },

      // Method to Clear Filters
      clearFilters(){
        this.$emit('clearFilters')
      },

      // Method for retry when api error occured
      retry(){
        this.$emit('retry')
      }
    }
}
</script>

